import {HubriseCurrencyCode} from 'common/api/hubrise/model/common/HubriseCurrencyCode';
import {isNullOrUndefined} from 'common/util/HelperUtil';
import {MathUtil} from 'common/util/MathUtil';

export class HubrisePriceUtil {
    public static sum(prices: (undefined | string)[], defaultCurrency: HubriseCurrencyCode = HubriseCurrencyCode.EUR): string {
        if (!Array.isArray(prices) || prices.length === 0) {
            return HubrisePriceUtil.amountToPrice(0, defaultCurrency);
        }
        if (prices.length === 1) {
            return prices[0];
        }
        const results: {
            amount: number,
            currency: HubriseCurrencyCode
        }[] = prices.map(price => HubrisePriceUtil.priceToAmount(price)).filter(result => result !== undefined);
        if (results.length === 0) {
            return HubrisePriceUtil.amountToPrice(0, defaultCurrency);
        }

        const total: number = MathUtil.sum(results.map(result => result.amount));

        return HubrisePriceUtil.amountToPrice(total, results[0].currency ?? defaultCurrency);
    }

    public static multiply(price?: string, multiplier?: number): string {
        if (isNullOrUndefined(price) || isNullOrUndefined(multiplier)) {
            return undefined;
        }
        if (multiplier === 1) {
            return price;
        }

        const result: { amount: number, currency: HubriseCurrencyCode } = HubrisePriceUtil.priceToAmount(price);
        if (result === undefined) {
            return undefined;
        }

        return HubrisePriceUtil.amountToPrice(result.amount * multiplier, result.currency);
    }

    public static priceToAmount(price: string): { amount: number, currency: HubriseCurrencyCode } {
        if (isNullOrUndefined(price)) {
            return undefined;
        }

        const parts: string[] = price.split(' ');
        if (parts.length !== 2) {
            return undefined;
        }

        return {
            amount: Number(parts.slice(0, parts.length - 1).join('')),
            currency: parts[parts.length - 1] as HubriseCurrencyCode
        };
    }

    public static amountToPrice(amount: number, currency: HubriseCurrencyCode): string {
        return String(MathUtil.round(amount, 2).toFixed(2)) + ' ' + String(currency);
    }
}
